import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {
    Badge,
    Text
} from "@mantine/core";
import {BillableUnit} from "../types.ts";

export const useTableColumns = (
    {onRecordClick}: { onRecordClick: (record: BillableUnit) => void },
) => {

    const columns: DataTableColumn<BillableUnit>[] = [
        {
            accessor: 'name',
            title: I18n.get('Billable Unit'),
            render: (record: BillableUnit) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.name}
                </Text>
            ),
        },
        {
            // FNP-802: the meter is the whole point of the module being visible — it is
            // what connects a priced unit back to what is actually measured. Prefer the
            // server-resolved meterCode; fall back to the raw id if the meter row is gone.
            accessor: 'meter',
            title: I18n.get('Meter'),
            render: (record: BillableUnit) => (
                <Text size="sm">{record.meter?.meterCode ?? record.meterId ?? '—'}</Text>
            ),
        },
        {
            accessor: 'meteredUnitsPerBillableUnit',
            title: I18n.get('Metered per Unit'),
            render: (record: BillableUnit) => {
                const factor = record.meteredUnitsPerBillableUnit ?? 1;
                // Spell out the 1:1 case rather than showing a bare "1" — it reads as a
                // real statement about the unit instead of a magic number.
                return <Text size="sm">{factor === 1 ? '1 : 1' : `${factor} : 1`}</Text>;
            },
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            render: (record: BillableUnit) => {
                if (!record.status) {
                    return <Text size="sm">—</Text>;
                }
                const color = record.status === 'ACTIVE'
                    ? 'green'
                    : record.status === 'RETIRED' ? 'gray' : 'yellow';
                return <Badge color={color} variant="light">{record.status}</Badge>;
            },
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
        },
    ];

    return {
        columns,
    };
};
